import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import set = Reflect.set;

@Component({
  selector: 'app-work-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css'],
})

export class PreviewComponent implements OnInit , AfterViewInit{
  @Input() previewSource: any;
  @Output() outPutClosePreview = new EventEmitter<any>();

  startScreen: boolean = false;
  safeUrl:any;
  isImgLoading: boolean = false;
  constructor(
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {

    console.log(this.previewSource);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewSource['fileUrl']);
    setTimeout(()=>{
      this.startScreen = true;
    },300);
    setTimeout(()=>{
      this.isImgLoading = true;
    },500);
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      $('.preview-body').eq(0).find('iframe').height($(window).height() - 44);
    })
  }

  close():void{
    this.startScreen = false;
    this.outPutClosePreview.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-preview/preview.component.ts